
import axios from 'axios';
import { HTTP } from '@/utils/http-common';
import Vue from 'vue';
export default Vue.extend({
  name: 'ContactForm',
  data() {
    return {
      name: '',
      tel: '',
      mail: '',
      message: '',
      agreement: false,
      loading: false,
      formAccepted: false,
      formError: false,
      longAgreement: false,
    };
  },
  methods: {
    sendMail() {
      this.loading = true;
      const formData = new FormData();
      formData.set('name', this.name);
      formData.set('tel', this.tel);
      formData.set('mail', this.mail);
      formData.set('message', this.message);
      formData.set('agreement', this.agreement ? 'Tak' : 'Nie');
      HTTP.post('https://rckik-katowice.pl/form-carter/index.php', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then((response) => {
        if (response.data.data.message === 'OK') {
          this.formAccepted = true;
          this.name = '';
          this.mail = '';
          this.tel = '';
          this.message = '';
          this.agreement = false;
        } else {
          this.formError = true;
        }
        this.loading = false;
      }).catch((e) => {
        this.formError = true;
        this.loading = false;
      });
    },
    showFullAgreement() {
      this.longAgreement = !this.longAgreement;
    },
  },
});
